import React, {useEffect, useState} from 'react';
import './style.scss';
import { menuItems, MESSAGES } from '../../constants';

//TODO according to the backend team the images are static and we show all or not, this will be updated once we build the noReports component.
import studentPrintable from '../../temp_files/studentPrintable.svg';
import studentPrintableSpanish from '../../temp_files/studentPrintableSpanish.svg';
import studentReport from '../../temp_files/studentReport.svg';
import schoolOverview from '../../temp_files/schoolOverview.svg';
import roster from '../../temp_files/roster.svg';
import schoolPrintable from '../../temp_files/schoolPrintable.svg';
import Benchmarks from '../../temp_files/Benchmarks.svg';
import districtOverview from '../../temp_files/districtOverview.svg';
import mismatchedCourses from '../../temp_files/mismatchedCourses.svg';
import deficientGrades from '../../temp_files/deficientGrades.svg';
import counselingBenchmarks from '../../temp_files/counselingBenchmarks.svg';
import ReportTab from "./reportTab";
import SubNavigationTabs from "../../components/common/subNavigationTabs";
import FinalReports from "../../components/FinalReports";
import {getFileStatuses} from "../../actions/schools";
import {useDispatch, useSelector} from "react-redux";
import {getBatchReports} from "../../actions/reports";
import {userCanAccess} from "../../utils/users";
import {setLoadingStatus} from "../../actions/session";
import LoadingSpinner from "../../components/common/loadingSpinner";

export const route = '/reports-gallery';

const PreliminaryReportTab = {
  name: 'preliminaryReports',
  title: 'Preliminary Reports',
  reportType: 'Preliminary',
  showSampleReports: true,
  noReportsMessage: MESSAGES.REPORTS.noReportsPreliminary,
  useSchoolCount: true,
  data: {
    reports: 0,
    studentReports: [
      {
        id: 'Student-1',
        title: 'Student Report 1',
        thumbnailUrl: studentReport,
        reportEndpoint: 'getStudent',
        useCurrentDistrict: true
      },
      {
        id: 'Student-2',
        title: 'Student Report 2',
        thumbnailUrl: studentPrintable,
        reportEndpoint: 'getStudentPrintable',
        useCurrentDistrict: true
      },
      {
        id: 'Student-3',
        title: 'Student Report 3',
        thumbnailUrl: studentPrintableSpanish,
        reportEndpoint: 'getStudentPrintableSpanish',
        useCurrentDistrict: true
      }
    ],
    schoolReports: [
      {
        id: 'School-1',
        title: 'School Report 1',
        thumbnailUrl: schoolOverview,
        reportEndpoint: 'getSchoolOverview',
        useCurrentDistrict: true
      },
      {
        id: 'School-2',
        title: 'School Report 2',
        thumbnailUrl: Benchmarks,
        reportEndpoint: 'getSchoolCourses',
        useCurrentDistrict: true
      },
      {
        id: 'School-3',
        title: 'School Report 3',
        thumbnailUrl: schoolPrintable,
        reportEndpoint: 'getSchoolPrintable',
        useCurrentDistrict: true
      },
      {
        id: 'School-4',
        title: 'School Report 4',
        thumbnailUrl: roster,
        reportEndpoint: 'getSchoolRoster',
        useCurrentDistrict: true
      }
    ],
    districtOverviewReports: [
      {
        id: 'DistrictOverview-1',
        title: 'District Overview',
        thumbnailUrl: districtOverview,
        reportEndpoint: 'getDistrictOverview',
        useCurrentDistrict: true
      }
    ],
    additionalReports: [
      {
        id: 'AdditionalReports-1',
        title: 'Mismatched Courses',
        thumbnailUrl: mismatchedCourses,
        reportEndpoint: 'getMismatchedCourses',
        useCurrentDistrict: true
      },
      {
        id: 'AdditionalReports-2',
        title: 'A-G Counseling Benchmarks',
        thumbnailUrl: counselingBenchmarks,
        reportEndpoint: 'getMismatchedCourses',
        pdfReport: true,
        pdfFileName: 'TES_Counseling_Benchmarks.pdf',
        useCurrentDistrict: false
      }
    ]
  }
}

const FinalReportTab = {
  name: 'finalReports',
  title: 'Final Reports',
  reportType: 'Final',
  showSampleReports: false,
  noReportsMessage: MESSAGES.REPORTS.noReportsFinal,
  useSchoolCount: true,
  data: {
    reports: 0,
    studentReports: [
      {
        id: 'Student-1',
        title: 'Student Report 1',
        thumbnailUrl: studentReport,
        reportEndpoint: 'getStudent',
        useCurrentDistrict: true
      },
      {
        id: 'Student-2',
        title: 'Student Report 2',
        thumbnailUrl: studentPrintable,
        reportEndpoint: 'getStudentPrintable',
        useCurrentDistrict: true
      },
      {
        id: 'Student-3',
        title: 'Student Report 3',
        thumbnailUrl: studentPrintableSpanish,
        reportEndpoint: 'getStudentPrintableSpanish',
        useCurrentDistrict: true
      }
    ],
    schoolReports: [
      {
        id: 'School-1',
        title: 'School Report 1',
        thumbnailUrl: schoolOverview,
        reportEndpoint: 'getSchoolOverview',
        useCurrentDistrict: true
      },
      {
        id: 'School-2',
        title: 'School Report 2',
        thumbnailUrl: Benchmarks,
        reportEndpoint: 'getSchoolCourses',
        useCurrentDistrict: true
      },
      {
        id: 'School-3',
        title: 'School Report 3',
        thumbnailUrl: schoolPrintable,
        reportEndpoint: 'getSchoolPrintable',
        useCurrentDistrict: true
      },
      {
        id: 'School-4',
        title: 'School Report 4',
        thumbnailUrl: roster,
        reportEndpoint: 'getSchoolRoster',
        useCurrentDistrict: true
      }
    ],
    districtOverviewReports: [
      {
        id: 'DistrictOverview-1',
        title: 'District Overview',
        thumbnailUrl: districtOverview,
        reportEndpoint: 'getDistrictOverview',
        useCurrentDistrict: true
      }
    ],
    additionalReports: [
      {
        id: 'AdditionalReports-1',
        title: 'Mismatched Courses',
        thumbnailUrl: mismatchedCourses,
        reportEndpoint: 'getMismatchedCourses',
        useCurrentDistrict: true
      },
      {
        id: 'AdditionalReports-2',
        title: 'Deficient Grades',
        thumbnailUrl: deficientGrades,
        reportEndpoint: 'getDeficientGrades',
        useCurrentDistrict: true
      },
      {
        id: 'AdditionalReports-3',
        title: 'A-G Counseling Benchmarks',
        thumbnailUrl: counselingBenchmarks,
        reportEndpoint: 'getMismatchedCourses',
        pdfReport: true,
        pdfFileName: 'TES_Counseling_Benchmarks.pdf',
        useCurrentDistrict: false
      }
    ]
  }
}

const HistoricalReportTab = {
  name: 'historicalReports',
  title: 'Historical Reports',
  reportType: null,
  useSchoolCount: false,
  data: {
    reports: 0,
    studentReports: null,
    schoolReports: [
      {
        id: 'historical-school',
        title: 'School Overview',
        thumbnailUrl: schoolOverview,
        reportEndpoint: 'getHistoricalSchool',
        useCurrentDistrict: true
      },
      {
        id: 'historical-course-report',
        title: 'School Course/GPA Benchmarks',
        thumbnailUrl: Benchmarks,
        reportEndpoint: 'getHistoricalSchoolCourse',
        useCurrentDistrict: true
      }
    ],
    districtOverviewReports: null,
    additionalReports: null
  }
};


const MyReports = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(FinalReportTab);

  const currentDistrict = useSelector((state) => state.districts.currentDistrict);
  const userComposite = useSelector((state) => state.session.currentUserComposite);

  const { studentReports, schoolReports, districtOverviewReports, additionalReports} = activeTab.data;

  useEffect(() => {
    async function getFileStatusesAndBatchReports() {
      await dispatch(setLoadingStatus(true));
      await dispatch(getFileStatuses(currentDistrict));
      await dispatch(setLoadingStatus(false));

      if (activeTab.reportType === 'Final' && userCanAccess(userComposite, 'batch-reports')) {
        await dispatch(getBatchReports());
      }

    }

    getFileStatusesAndBatchReports();
  }, [activeTab, userComposite, currentDistrict, dispatch]);

  const schoolStatuses = useSelector((state) => state.schools.schoolStatuses);
  const batchReports = useSelector((state) => state.reports.batchReports);
  let reportsDistrict = null;


  const isLoading = useSelector((state) => state.session.isLoading);

  const reportMenuItems = menuItems.map((item) => {
    let itemTab = null;
    switch (item.label) {
      case 'Preliminary':
        itemTab = PreliminaryReportTab;
        break;
      case 'Final':
        itemTab = FinalReportTab;
        break
      case 'Historical':
        itemTab = HistoricalReportTab;
        break;
      default:
        break;
    }

    item['onClickAction'] = () => {
      setActiveTab(itemTab);
    }

    return item;
  });

  function returnTab() {
    switch (activeTab.name) {
      case 'finalReports':
        return <FinalReports activeTab={activeTab} studentReports={studentReports} schoolReports={schoolReports} districtOverviewReports={districtOverviewReports} additionalReports={additionalReports} useSchoolCount={activeTab.useSchoolCount} schoolStatuses={schoolStatuses} batchReports={batchReports} reportsDistrict={reportsDistrict} userComposite={userComposite}/>
      default:
        return  <ReportTab tabTitle={activeTab.title} studentReports={studentReports} schoolReports={schoolReports} districtOverviewReports={districtOverviewReports} additionalReports={additionalReports} data={activeTab.data} reportComponent={activeTab.reportComponent} reportType={activeTab.reportType} showSampleReports={(activeTab.showSampleReports && userCanAccess(userComposite, 'sample-reports'))} noReportsMessage={activeTab.noReportsMessage} useSchoolCount={activeTab.useSchoolCount} schoolStatuses={schoolStatuses} reportsDistrict={reportsDistrict}/>
    }
  }

  const reportsLoaded = <>
    <SubNavigationTabs items={reportMenuItems} currentTabName={activeTab.name}/>
    {returnTab()}
  </>

  return (
    <div className='main-content'>
      <div className="reports-container">
        {(isLoading) ? <LoadingSpinner /> : reportsLoaded}
      </div>
    </div>
  );
};

export default MyReports;
